module.exports = __webpack_public_path__ + "static/media/ambassador-overview.d09a8e5f.mp4";